import { IUser } from 'app/shared/model/user.model';
import { IEcole } from './ecole.model';

export interface IDirecteur {
  id?: string;
  ecole?: IEcole | null;
  firstName?: string;
  lastName?: string;
  telephone?: number;
  authorities?: any[];
  login?: string;
  email?: string;
  activated?: boolean;
  ecoleId?: string;
  user?: IUser | null;
  directeurAuthority: string;
}

export const defaultValue: Readonly<IDirecteur> = {
  id: null,
  ecole: null,
  firstName: '',
  lastName: '',
  telephone: null,
  authorities: [],
  login: '',
  email: '',
  activated: true,
  ecoleId: '',
  user: null,
  directeurAuthority: '',
};
